<template>
	<vx-card no-shadow v-if="showWindow">
		<vs-popup classContent="popup-example" title="Update document number" :active.sync="popUps.updateActionDoc">
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-input class="inputx w-full" label="New doc number" v-model="params.new_doc_number" />
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<label>Doc type</label>
					<select v-model="params.docType" class="inputx w-full" label="Doc Type">
						<option>ID</option>
						<option>passport</option>
						<option>drivers license</option>
					</select>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<flat-pickr :config="configTodateTimePicker" v-model="params.dob" placeholder="dob" />
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-button @click="updateDocNumber()" color="primary" type="filled">Update</vs-button>
				</div>
			</div>
		</vs-popup>
		<vs-popup classContent="popup-example" title="Update document" :active.sync="popUps.updateDoc">
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-input class="inputx w-full" label="Doc Id" v-model="params.doc_id" readonly />
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-input class="inputx w-full" label="Doc name" v-model="params.doc_name" />
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-input class="inputx w-full" label="Doc unique" v-model="params.doc_unique" readonly />
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<label>Status</label>
					<select v-model="params.status" class="inputx w-full" label="Status">
						<option>declined</option>
						<option>approved</option>
					</select>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<label>Reason</label>
					<select v-model="params.reason" class="form-control inputx w-full">
						<option></option>
						<option>bad pic</option>
						<option>brand</option>
						<option>outdated</option>
						<option>mismatching details</option>
						<option>client request</option>
						<option>wrong doc</option>
						<option>compliance</option>
						<option>suspected fraud</option>
					</select>
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-input class="inputx w-full" label="Comment" v-model="params.comment" />
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-button @click="sendData()" color="primary" type="filled">Update</vs-button>
				</div>
			</div>
		</vs-popup>
		<vs-popup fullscreen classContent="popup-example" title="Update document" :active.sync="popUps.updateDocName">
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-input class="inputx w-full" label="Doc Id" v-model="params.doc_id" readonly />
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-input class="inputx w-full" label="Doc name" v-model="params.doc_name" />
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					File type
					<v-select :closeOnSelect="true" v-model="params.fileType" :options="fileTypes"
						:dir="$vs.rtl ? 'rtl' : 'ltr'" @input="showTransactions" />
				</div>
			</div>
			<div class="vx-row mb-6">
				<div class="vx-col w-full">
					<vs-button @click="sendDocData()" color="primary" type="filled">Update</vs-button>
				</div>
			</div>
			<br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
		</vs-popup>
		<!-- START ADDED: Download All button above the table -->
		<div class="vx-row mb-4" style="text-align: right;">
			<div class="vx-col w-full">
				<!-- changed type from "outline" to "filled" so text is visible -->
				<vs-button @click="downloadAll" color="primary" type="filled">
					Download All
				</vs-button>
			</div>
		</div>
		<!-- END ADDED -->
		<table-view :component-key="componentKey" :end-point="endPoint" :column-defs="columnDefs" :line-details="params"
			:filters="filters" :call-params="callParams" :call-url="'/api/client'" :pop-ups="popUps">
		</table-view>
	</vx-card>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import tableView from '../../components/tableView';
import saleStatus from '../../../resources/sale_status.json';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
export default {
	data() {
		const params = new URLSearchParams();
		params.append('type', 'get-docs');
		params.append('email', this.$route.params.email);
		let data = {
			fileTypes: this.$store.state.docNames,
			componentKey: 0,
			popUps: {
				updateDoc: false,
				updateDocName: false,
				updateActionDoc: false
			},
			configTodateTimePicker: {
				minDate: null
			},
			showTransactions: [],
			params: {},
			saleStatus: saleStatus,
			tableData: [],
			filters: { disable: true },
			tableView,
			endPoint: 'clientDocs',
			callParams: params,
		}
		data.columnDefs = [

			/*
			{
			  headerName: 'doc_number',
			  field: 'doc_number',
			  filter: true,
			  width: 250,
			  action: 'updateDoc',
			  cellStyle: {color: 'blue'}
			},   
			{
			  headerName: 'doc_unique',
			  field: 'doc_unique',
			  filter: true,
			  width: 250,
			  action: 'username',
			  cellStyle: {color: 'blue'}
			},
			{
			  headerName: 'update name',
			  field: 'updateDocName',
			  filter: true,
			  width: 125,
			  action: 'updateDocName',
			  cellStyle: {color: 'blue'},
			  cellRenderer: function() {
				return 'Update name';
			  }
			},
			{
			  headerName: 'action',
			  field: 'action',
			  filter: true,
			  width: 125,
			  action: 'actionDoc',
			  cellRenderer: function() {
				return 'Edit Number';
			  }
			},
			*/
			{
				headerName: 'doc_id',
				field: 'doc_id',
				filter: true,
				width: 250,
				action: 'updateDoc',
				cellStyle: { color: 'blue' }
			},
			{
				headerName: 'Upload Date',
				field: 'upload_date',
				filter: true,
				width: 125
			},
			{
				headerName: 'Type',
				field: 'doc_name',
				width: 125,
				filter: true,
			},


			{
				headerName: 'Status',
				field: 'ver_status',
				filter: true,
				action: 'updateDoc',
				cellStyle: { color: 'blue' },
				width: 125,
			},

			{
				headerName: 'View',
				field: 'file_location',
				filter: true,
				width: 125,
				action: 'video',
				cellStyle: { color: 'blue' },
				cellRenderer: function (params) {
					const ext = params.value.split('.');
					if (ext.at(-1) === 'mp4')
						return 'Play';
					return '<img width="125" src="/docs/' + params.value + '">';
				}
			},
			{
				headerName: 'Last Updated',
				field: 'updated_at',
				filter: true,
				width: 150,
			}

		]
		return data;
	},
	components: {
		'v-select': vSelect,
		tableView,
		flatPickr
	},
	computed: {
		showWindow() {
			if (this.$route.path.indexOf('/clients/') !== -1) {
				//if(this.fieldsData.length===0)
				//this.setData();
				return true;
			}
			return false;
		},
		activeUserInfo() {
			return this.$store.state.AppActiveUser
		},

	},
	methods: {
		setData: function () {
			let that = this;
			const params = new URLSearchParams();
			params.append('type', 'get-docs');
			params.append('email', this.$route.params.email);
			axios.post("/api/client", params)
				.then((response) => {
					console.log(response)
					that.tableData.splice(0);
					for (let i in response.data) {
						let data = JSON.parse(response.data[i].object);
						this.tableData.push(data);
					}
				})
				.catch(() => { })
		},
		showPopup: function (data) {
			//this.params.status = data.status;
			this.params.doc_name = data.doc_name;
			this.params.doc_unique = data.doc_unique;
			this.params.doc_id = data.doc_id;
			this.popUps.updateDoc = true;
		},
		openAlert(color, title, text) {
			let colorAlert = color;
			this.$vs.notify({
				title: title,
				text: text,
				color: colorAlert
			})
		},
		updateDocNumber: function () {
			let that = this;
			const params = new URLSearchParams();
			params.append('type', 'update-doc-number');
			params.append('email', this.$route.params.email);
			params.append('doc_name', this.params.doc_name);
			params.append('doc_id', this.params.doc_id);
			params.append('new_doc_number', this.params.new_doc_number);
			params.append('doc_unique', this.params.doc_unique);
			params.append('dob', this.params.dob);
			params.append('doc_type', this.params.docType);
			this.$vs.loading();
			axios.post("/api/client", params)
				.then((data) => {
					//that.setData(true);
					that.$vs.loading.close();
					if (data.data[0].out1 === 'done!' || data.data[0].out1 === 'Doc Status Updated!') {
						let status = that.params.status;
						that.params = { status: status };
						that.popUps.updateDoc = false;
						that.componentKey++;
						that.openAlert('success', 'Success', data.data[0].out1);
					} else
						that.openAlert('danger', 'Failed', data.data[0].out1);
				})
				.catch((data) => { that.$vs.loading.close(); that.openAlert('danger', 'Failed', data[0].out1); })
		},
		sendDocData: function () {
			let that = this;
			this.params.type = 'update-doc-name';
			this.params.email = this.$route.params.email;
			this.$vs.loading();
			axios.post("/api/client", this.params)
				.then((data) => {
					//that.setData(true);
					that.$vs.loading.close();
					if (data.data[0].out1 === 'done!' || data.data[0].out1 === 'Doc Status Updated!') {
						let status = that.params.status;
						that.params = { status: status };
						that.popUps.updateDoc = false;
						that.componentKey++;
						that.openAlert('success', 'Success', data.data[0].out1);
					} else
						that.openAlert('danger', 'Failed', data.data[0].out1);
				})
				.catch((data) => { that.$vs.loading.close(); that.openAlert('danger', 'Failed', data[0].out1); })
		},
		sendData: function () {
			let that = this;
			const params = new URLSearchParams();
			params.append('type', 'update-doc');
			params.append('email', this.$route.params.email);
			params.append('doc_name', this.params.doc_name);
			params.append('doc_id', this.params.doc_id);
			params.append('doc_unique', this.params.doc_unique);
			params.append('status', this.params.status);
			params.append('reason', this.params.reason);
			params.append('comment', this.params.comment);
			if (this.params.status == 'declined' && (this.params.reason === '' || this.params.reason === undefined)) {
				that.openAlert('danger', 'Failed', 'Reason can not be empty');
				return false;
			}
			this.$vs.loading();
			axios.post("/api/client", params)
				.then((data) => {
					//that.setData(true);
					that.$vs.loading.close();
					if (data.data[0].out1 === 'done!' || data.data[0].out1 === 'Doc Status Updated!') {
						let status = that.params.status;
						that.params = { status: status };
						that.popUps.updateDoc = false;
						that.componentKey++;
						that.openAlert('success', 'Success', data.data[0].out1);
					} else
						that.openAlert('danger', 'Failed', data.data[0].out1);
				})
				.catch((data) => { that.$vs.loading.close(); that.openAlert('danger', 'Failed', data[0].out1); })
		},
		// START ADDED
		/**
		 * Fetches the list of docs and triggers a download for each file.
		 */
		async downloadAll() {
			const params = new URLSearchParams();
			params.append('type', 'get-docs');
			params.append('email', this.$route.params.email);

			try {
				const response = await axios.post("/api/client", params);
				const zip = new JSZip();

				// 1. Fetch each file as a blob and add to the zip
				const addFilePromises = response.data.map(async item => {
					const doc = JSON.parse(item.object);
					const fileName = doc.file_location;
					if (!fileName) return;

					const fileUrl = `/docs/${fileName}`;
					const fileResp = await fetch(fileUrl);
					if (!fileResp.ok) {
						console.warn(`Failed to fetch ${fileName}`);
						return;
					}
					const blob = await fileResp.blob();
					// add to zip under its filename
					zip.file(fileName, blob);
				});

				// wait for all fetches to finish
				await Promise.all(addFilePromises);

				// 2. Generate the zip file and trigger download
				const zipBlob = await zip.generateAsync({ type: 'blob' });
				saveAs(zipBlob, `${this.$route.params.email}-docs.zip`);
			}
			catch (err) {
				console.error(err);
				this.openAlert('danger', 'Failed', 'Could not download files');
			}
		}
		// END ADDED
	}
}
</script>
